module.exports = __webpack_public_path__ + "static/media/MAAS_JourneyPlanning1.20bf0718.png";